import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.infobox)?_c(VCard,{staticClass:"px-8 py-6 infobox-content",style:('left: '+_vm.position+';'),attrs:{"height":"fit-content"}},[_c('p',{staticClass:"text-description",domProps:{"innerHTML":_vm._s(_vm.infoboxText)}},[_vm._v("\n    "+_vm._s(_vm.infoboxText)+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }